export default __webpack_public_path__ + "static/media/cfb-logo.ab3bfec0.svg";